import { Injectable, inject } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AppService } from '../../app.service';
import { EnvironmentService } from '../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class SentryErrorService {
  private envService: EnvironmentService = inject(EnvironmentService);
  private appService: AppService = inject(AppService);

  initSentry() {
    Sentry.init({
      dsn: 'https://3d6d5f6ff46f8dbfcaf9fade1653817e@o46994.ingest.sentry.io/4506383205728256',
      release: this.envService.version,
      environment: this.envService.env,
      beforeSend: (event, hint) => this.sentryBeforeSend(event, hint),
    });
  }

  sentryBeforeSend(event, hint) {
    if (this.envService.isLocal) {
      return null;
    }

    // filter out uninteresting http errors
    if (event.message?.toLowerCase().includes('http')) {
      for (const statusCode of ['404', '403', '500']) {
        if (event.message.includes(statusCode)) return null;
      }
    }

    // Check if this is a raw HTTP Response object being thrown as an exception
    const originalException = hint?.originalException;
    if (originalException && typeof originalException === 'object') {
      const exceptionKeys = Object.keys(originalException);
      const isHttpResponse =
        exceptionKeys.includes('status') && exceptionKeys.includes('url');

      if (isHttpResponse) {
        // Convert HTTP Response object to a proper error message
        const httpObj = originalException as any;
        event.message = `HTTP ${httpObj.status}: ${httpObj.statusText || 'Error'} - ${httpObj.url}`;
        event.level = 'error';

        // Add HTTP details as extra context
        if (!event.extra) event.extra = {};
        event.extra.httpStatus = httpObj.status;
        event.extra.httpUrl = httpObj.url;
        event.extra.httpStatusText = httpObj.statusText;
      }
    }

    if (!event.tags) event.tags = {};
    const maybeTicketId = this.appService.currentTicketId();
    if (maybeTicketId) {
      event.tags.ticketId = maybeTicketId;
    }

    return event;
  }
}
